/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef } from 'react';
import { DatePickerInput } from '@carbon/react';
import DatePickerWrapper from '../../DatePickerWrapper/DatePickerWrapper.js';
import { useTranslation } from '../../../../Utilities/i18n/i18n.js';
import useId from '../../../../Utilities/id/useId.js';

var _excluded = ["columnKey", "onChange", "mode", "initialSelectedItems"];

/* eslint-disable react/prop-types */

var hoc = function hoc(WrappedComponent) {
  return function (_ref) {
    var _datepickerRef$curren;
    var columnKey = _ref.columnKey,
      onChange = _ref.onChange,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'live' : _ref$mode,
      _ref$initialSelectedI = _ref.initialSelectedItems,
      initialSelectedItems = _ref$initialSelectedI === void 0 ? [] : _ref$initialSelectedI,
      passthroughProps = _objectWithoutProperties(_ref, _excluded);
    var datepickerRef = useRef(null);
    var datePickerId = (passthroughProps === null || passthroughProps === void 0 ? void 0 : passthroughProps.id) || useId('datatable-filter-datepicker');
    var disabled = passthroughProps === null || passthroughProps === void 0 ? void 0 : passthroughProps.disabled;
    var augmentedOnChange = function augmentedOnChange(args) {
      onChange({
        selectedItems: args,
        columnKey: columnKey,
        isDateRange: true,
        mode: mode
      });
    };
    var _useTranslation = useTranslation(),
      t = _useTranslation.t;
    var start;
    var end;
    if (Array.isArray(initialSelectedItems) && initialSelectedItems[0] && initialSelectedItems[0].start instanceof Date && initialSelectedItems[0].end instanceof Date) {
      start = initialSelectedItems[0].start;
      end = initialSelectedItems[0].end;
    }
    if (Array.isArray((_datepickerRef$curren = datepickerRef.current) === null || _datepickerRef$curren === void 0 || (_datepickerRef$curren = _datepickerRef$curren.cal) === null || _datepickerRef$curren === void 0 ? void 0 : _datepickerRef$curren.selectedDates) && !datepickerRef.current.cal.selectedDates.length && initialSelectedItems.length) {
      datepickerRef.current.cal.setDate([start, end], false);
    }
    return /*#__PURE__*/React.createElement(WrappedComponent
    // eslint-disable-next-line react/jsx-props-no-spreading
    , _extends({}, passthroughProps, {
      columnKey: columnKey,
      id: datePickerId,
      onChange: augmentedOnChange,
      datePickerType: "range",
      dateFormat: "m/d/Y",
      className: "cds--dropdown_wrapper",
      ref: datepickerRef
    }), /*#__PURE__*/React.createElement(DatePickerInput, {
      id: "".concat(datePickerId, "-start"),
      placeholder: start ? start.toLocaleDateString() : t('Start date'),
      labelText: passthroughProps.titleText,
      autoComplete: "off",
      disabled: disabled
    }), /*#__PURE__*/React.createElement(DatePickerInput, {
      id: "".concat(datePickerId, "-end"),
      placeholder: end ? end.toLocaleDateString() : t('End date'),
      labelText: passthroughProps.titleTextEnd ? passthroughProps.titleTextEnd : '',
      autoComplete: "off",
      disabled: disabled
    }));
  };
};

// Use our wrapper that fixes some language issues
var TableToolbarDateRangeSelect = hoc(DatePickerWrapper);
var TableToolbarDateRangeSelect$1 = TableToolbarDateRangeSelect;

export { TableToolbarDateRangeSelect$1 as default };
